/**
 * Opens a blank tab during the current user gesture, then navigates after
 * `resolveUrl` settles. `window.open` after `await` is blocked by browsers.
 * Keep `window.open` in this non-async function so regenerator cannot defer it.
 * @param {() => Promise<string>} resolveUrl
 * @returns {Promise<void>}
 */
export function openResolvedUrlInNewTab (resolveUrl) {
  const popup = window.open('about:blank', '_blank')
  if (!popup) {
    const err = new Error('popup-blocked')
    err.code = 'popup-blocked'
    return Promise.reject(err)
  }
  popup.opener = null
  return Promise.resolve()
    .then(() => resolveUrl())
    .then((url) => {
      if (popup.closed) return
      popup.location.replace(url)
    })
    .catch((e) => {
      if (!popup.closed) popup.close()
      throw e
    })
}



// WEBPACK FOOTER //
// ./src/lib/openResolvedUrlInNewTab.js